// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.padding-wrapper-content {
  padding: 0 10px 16px 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
}

.adv-parent-temp-wrapper {
  display: inline-block;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  box-shadow: 0px 1px 2px -1px rgba(16, 24, 40, 0.1), 0px 1px 3px 0px rgba(16, 24, 40, 0.1);
  background: var(--sdk-global-white-bg);
}
.adv-parent-temp-wrapper.list-with-border-multi-items .adv-parent-acc-list:last-child::before {
  display: none;
}
.adv-parent-temp-wrapper.list-with-border-multi-items .adv-parent-acc-list::before {
  content: "";
  position: absolute;
  width: calc(100% - 20px);
  height: 1px;
  background: var(--sdk-gloabl-border-color);
  bottom: 0;
  left: 10px;
}
.adv-parent-temp-wrapper .tabs-sec-data {
  padding: 0px 10px;
  display: flex;
  gap: 8px 16px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.adv-parent-temp-wrapper .tabs-sec-data .tab-name {
  border: 0;
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  padding: 10px 12px;
  min-width: 44px;
  min-height: 44px;
  border-bottom: 2px solid var(--sdk-global-white-bg);
  background: var(--sdk-global-white-bg);
  transition: 0.3s all ease;
}
.adv-parent-temp-wrapper .tabs-sec-data .tab-name:hover {
  border-bottom: 2px solid var(--sdk-global-theme-color);
}
.adv-parent-temp-wrapper .tabs-sec-data .tab-name.active-tab {
  border-bottom: 2px solid var(--sdk-global-theme-color);
}
.adv-parent-temp-wrapper .drp-content-menu {
  display: none;
  position: absolute;
  left: auto;
  right: 0;
  z-index: 9;
  border: 1px solid var(--sdk-gloabl-border-color);
  box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.1), 0px 4px 6px -1px rgba(16, 24, 40, 0.1);
  background: var(--sdk-global-white-bg);
  margin-top: 2px;
  top: 34px;
  border-radius: 4px;
  width: 200px;
}
.adv-parent-temp-wrapper .drp-content-menu .close-drp-down {
  float: right;
  border: 0;
  padding: 0;
  background: transparent;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin: 5px;
}
.adv-parent-temp-wrapper .drp-content-menu .close-drp-down svg path {
  fill: var(--sdk-gloabl-text-color);
}
.adv-parent-temp-wrapper .drp-content-menu li {
  border-radius: 4px 4px 0px 0px;
  background: var(--sdk-global-white-bg);
  display: flex;
  padding: 5px 16px;
  width: 100%;
  align-items: center;
  align-self: stretch;
  gap: 10px;
  cursor: pointer;
  transition: 0.2s all ease;
  list-style-type: none;
}
.adv-parent-temp-wrapper .main-heading-wrapper {
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.adv-parent-temp-wrapper .main-heading-wrapper h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.adv-parent-temp-wrapper .main-heading-wrapper .header-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 10px;
  position: relative;
}
.adv-parent-temp-wrapper .main-heading-wrapper .header-actions .btn-action-filter {
  width: 16px;
  height: 16px;
  padding: 0;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
}
.adv-parent-temp-wrapper .main-heading-wrapper .header-actions .btn-action-filter svg path {
  fill: var(--sdk-gloabl-text-color);
}
.adv-parent-temp-wrapper .main-heading-wrapper .header-actions .input-search {
  position: absolute;
  right: 0;
  top: -8px;
  width: 146px;
  height: 34px;
  padding: 6px 10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  border-radius: 8px;
  border: 1px solid var(--sdk-gloabl-border-color);
  background: var(--sdk-global-white-bg);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  color: var(--sdk-gloabl-text-color);
  outline: 0;
  z-index: 1;
}
.adv-parent-temp-wrapper .main-heading-wrapper .header-actions .input-search::placeholder {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  opacity: 0.5;
}
.adv-parent-temp-wrapper .main-heading-wrapper .header-actions .input-search:focus {
  border: 1px solid var(--sdk-global-theme-color);
  box-shadow: 0px 0px 0px 4px var(--sdk-global-theme-color), 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
.adv-parent-temp-wrapper .main-heading-wrapper .header-actions .input-search:active {
  border: 1px solid var(--sdk-global-theme-color);
  box-shadow: 0px 0px 0px 4px var(--sdk-global-theme-color), 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
.adv-parent-temp-wrapper .adv-parent-acc-list {
  display: inline-block;
  width: 100%;
  height: 100%;
  position: relative;
}
.adv-parent-temp-wrapper .adv-parent-acc-list.open-acc-adv-temp .advanced-list-template-wrapper .right-actions-content .arrow-icon {
  transform: rotate(90deg);
}
.adv-parent-temp-wrapper .adv-parent-acc-list.open-acc-adv-temp .adv-list-temp-accordion {
  display: block;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px;
  gap: 15px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .border-div-indication {
  flex-shrink: 0;
  border-radius: 4px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .img-block {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .img-block.xs {
  width: 16px;
  height: 16px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .img-block.lg {
  width: 60px;
  height: 60px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .img-block.xlg {
  width: 80px;
  height: 80px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .img-block figure {
  line-height: 0px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .img-block img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .img-block img.radius-100 {
  border-radius: 100%;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .titles-info-block {
  width: 100%;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .titles-info-block h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .titles-info-block p {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.271px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content {
  flex-shrink: 0;
  gap: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content .arrow-icon {
  font-size: 10px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content .arrow-icon svg path {
  fill: var(--sdk-gloabl-text-color);
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content .tag-status {
  display: flex;
  padding: 2px 6px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  background: var(--sdk-gloabl-bg-secondary);
  color: var(--green-2, #27AE60);
  font-size: 10px;
  font-weight: 400;
  line-height: 17px;
  margin: 0;
  border: 1px solid transparent;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content .dropdown-list-wrapper {
  width: auto;
  position: relative;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content .dropdown-list-wrapper.show-drp .elipse-dropdown {
  background: var(--sdk-gloabl-bg-secondary);
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content .dropdown-list-wrapper.show-drp .drp-content-menu {
  display: block;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content .dropdown-list-wrapper .elipse-dropdown {
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 14px;
  border-radius: 4px;
  transition: 0.2s all ease;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content .dropdown-list-wrapper .elipse-dropdown svg path {
  fill: var(--sdk-gloabl-text-color);
}
.adv-parent-temp-wrapper .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content .dropdown-list-wrapper .elipse-dropdown:hover {
  background: var(--sdk-gloabl-bg-secondary);
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion {
  padding: 10px;
  -webkit-animation-name: slideOutDown;
  animation-name: slideOutDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  display: none;
  position: relative;
  z-index: 2;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .list-of-rows {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .list-of-rows .row-list-info {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .list-of-rows .row-list-info figure {
  line-height: 0;
  position: relative;
  top: 2px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .list-of-rows .row-list-info figure img {
  width: 16px;
  height: 16px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .list-of-rows .row-list-info p {
  color: var(--sdk-gloabl-text-color);
  font-size: 12px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0.3px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .buttons-wrapper-sec {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  position: relative;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .buttons-wrapper-sec.if-full-width-buttons {
  flex-wrap: wrap;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .table-list-data {
  display: flex;
  flex-wrap: wrap;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .table-list-data.if-column-type .table-body-data {
  flex: 1 1 50%;
  flex-direction: row;
  align-items: center;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  flex: 1 1 33.333%;
  padding: 10px;
  gap: 10px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .img_block {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .img_block.xs {
  width: 16px;
  height: 16px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .img_block.md {
  width: 40px;
  height: 40px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .img_block.lg {
  width: 60px;
  height: 60px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .img_block.xlg {
  width: 80px;
  height: 80px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .img_block figure {
  line-height: 0px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .img_block img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .img_block img.radius-100 {
  border-radius: 100%;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .titles_info_block {
  width: 100%;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .titles_info_block p {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 2px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .titles_info_block h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.271px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .checkbox-list-data-tems {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .checkbox-list-data-tems .checkbox-item {
  width: 100%;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .checkbox-list-data-tems .radio-button-item .radio-input {
  width: 25px;
  height: 25px;
  top: 9px;
  left: 10px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .checkbox-list-data-tems .radio-button-item .radio-input:checked + .radio-label {
  background: var(--sdk-gloabl-bg-secondary);
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .checkbox-list-data-tems .radio-button-item .radio-input + .radio-label {
  padding: 12px 10px;
  padding-left: 46px;
  width: 100%;
  border-radius: 4px;
}
.adv-parent-temp-wrapper .adv-parent-acc-list .adv-list-temp-accordion .checkbox-list-data-tems .radio-button-item .radio-input + .radio-label::before {
  left: 10px;
  top: 8px;
}
.adv-parent-temp-wrapper .see-more-link {
  padding: 10px;
  text-align: right;
}
.adv-parent-temp-wrapper .see-more-link .see-more-btn {
  display: inline-flex;
  padding: 5px 10px;
  align-items: center;
  gap: 10px;
  border: 0;
  color: var(--sdk-global-theme-color);
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  background: transparent;
  height: 34px;
}
.adv-parent-temp-wrapper .see-more-link .see-more-btn svg path {
  fill: var(--sdk-gloabl-text-color);
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/advancedMulitList/advancedMultiList.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;AACJ;;AAEA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yFAAA;EACA,sCAAA;AACJ;AAIgB;EACI,aAAA;AAFpB;AAMY;EACI,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,WAAA;EACA,0CAAA;EACA,SAAA;EACA,UAAA;AAJhB;AASI;EACI,iBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AAPR;AASQ;EACI,SAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mDAAA;EACA,sCAAA;EACA,yBAAA;AAPZ;AASY;EACI,sDAAA;AAPhB;AAUY;EACI,sDAAA;AARhB;AAaI;EACI,aAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,gDAAA;EACA,0FAAA;EACA,sCAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AAXR;AAaQ;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAXZ;AAcgB;EACI,kCAAA;AAZpB;AAiBQ;EACI,8BAAA;EACA,sCAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;AAfZ;AAmBI;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAjBR;AAmBQ;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAjBZ;AAoBQ;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;AAlBZ;AAoBY;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;AAlBhB;AAqBoB;EACI,kCAAA;AAnBxB;AAwBY;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gDAAA;EACA,sCAAA;EACA,kDAAA;EACA,mCAAA;EACA,UAAA;EACA,UAAA;AAtBhB;AAwBgB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAtBpB;AAyBgB;EACI,+CAAA;EACA,iGAAA;AAvBpB;AA0BgB;EACI,+CAAA;EACA,iGAAA;AAxBpB;AA8BI;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA5BR;AAiCoB;EACI,wBAAA;AA/BxB;AAoCY;EACI,cAAA;AAlChB;AAsCQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AApCZ;AAsCY;EACI,cAAA;EACA,kBAAA;AApChB;AAuCY;EACI,cAAA;EACA,WAAA;EACA,YAAA;AArChB;AAuCgB;EACI,WAAA;EACA,YAAA;AArCpB;AAwCgB;EACI,WAAA;EACA,YAAA;AAtCpB;AAyCgB;EACI,WAAA;EACA,YAAA;AAvCpB;AA0CgB;EACI,gBAAA;AAxCpB;AA2CgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAzCpB;AA2CoB;EACI,mBAAA;AAzCxB;AA8CY;EACI,WAAA;AA5ChB;AAiDgB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA/CpB;AAsDgB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AApDpB;AA4DY;EACI,cAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AA1DhB;AA4DgB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA1DpB;AA6DgB;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;AA3DpB;AA8DwB;EACI,kCAAA;AA5D5B;AAiEgB;EACI,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,0CAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,6BAAA;AA/DpB;AAkEgB;EACI,WAAA;EACA,kBAAA;AAhEpB;AAmEwB;EACI,0CAAA;AAjE5B;AAoEwB;EACI,cAAA;AAlE5B;AAsEoB;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AApExB;AAuE4B;EACI,kCAAA;AArEhC;AAyEwB;EACI,0CAAA;AAvE5B;AA8EQ;EACI,aAAA;EACA,oCAAA;EACA,4BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AA5EZ;AA8EY;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;AA5EhB;AA8EgB;EACI,aAAA;EACA,uBAAA;EACA,SAAA;AA5EpB;AA8EoB;EACI,cAAA;EACA,kBAAA;EACA,QAAA;AA5ExB;AA8EwB;EACI,WAAA;EACA,YAAA;AA5E5B;AAgFoB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AA9ExB;AAmFY;EACI,aAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAjFhB;AAmFgB;EACI,eAAA;AAjFpB;AAqFY;EACI,aAAA;EACA,eAAA;AAnFhB;AAsFoB;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AApFxB;AAwFgB;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;AAtFpB;AAwFoB;EACI,cAAA;EACA,WAAA;EACA,YAAA;AAtFxB;AAwFwB;EACI,WAAA;EACA,YAAA;AAtF5B;AAyFwB;EACI,WAAA;EACA,YAAA;AAvF5B;AA0FwB;EACI,WAAA;EACA,YAAA;AAxF5B;AA2FwB;EACI,WAAA;EACA,YAAA;AAzF5B;AA4FwB;EACI,gBAAA;AA1F5B;AA6FwB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AA3F5B;AA6F4B;EACI,mBAAA;AA3FhC;AAgGoB;EACI,WAAA;AA9FxB;AAgGwB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AA9F5B;AAiGwB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AA/F5B;AAqGY;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AAnGhB;AAqGgB;EACI,WAAA;AAnGpB;AAuGoB;EACI,WAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;AArGxB;AAwG4B;EACI,0CAAA;AAtGhC;AA0GwB;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAxG5B;AA0G4B;EACI,UAAA;EACA,QAAA;AAxGhC;AAiHI;EACI,aAAA;EACA,iBAAA;AA/GR;AAiHQ;EACI,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;AA/GZ;AAkHgB;EACI,kCAAA;AAhHpB","sourcesContent":[".padding-wrapper-content {\n    padding: 0 10px 16px 16px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 10px;\n}\n\n.adv-parent-temp-wrapper {\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n    border-radius: 4px;\n    box-shadow: 0px 1px 2px -1px rgba(16, 24, 40, 0.10), 0px 1px 3px 0px rgba(16, 24, 40, 0.10);\n    background: var(--sdk-global-white-bg);\n\n    &.list-with-border-multi-items {\n        .adv-parent-acc-list {\n            &:last-child {\n                &::before {\n                    display: none;\n                }\n            }\n\n            &::before {\n                content: \"\";\n                position: absolute;\n                width: calc(100% - 20px);\n                height: 1px;\n                background: var(--sdk-gloabl-border-color);\n                bottom: 0;\n                left: 10px;\n            }\n        }\n    }\n\n    .tabs-sec-data {\n        padding: 0px 10px;\n        display: flex;\n        gap: 8px 16px;\n        flex-wrap: wrap;\n        margin-bottom: 10px;\n\n        .tab-name {\n            border: 0;\n            color: var(--sdk-gloabl-text-color);\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 20px;\n            padding: 10px 12px;\n            min-width: 44px;\n            min-height: 44px;\n            border-bottom: 2px solid var(--sdk-global-white-bg);\n            background: var(--sdk-global-white-bg);\n            transition: 0.3s all ease;\n\n            &:hover {\n                border-bottom: 2px solid var(--sdk-global-theme-color);\n            }\n\n            &.active-tab {\n                border-bottom: 2px solid var(--sdk-global-theme-color);\n            }\n        }\n    }\n\n    .drp-content-menu {\n        display: none;\n        position: absolute;\n        left: auto;\n        right: 0;\n        z-index: 9;\n        border: 1px solid var(--sdk-gloabl-border-color);\n        box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.10), 0px 4px 6px -1px rgba(16, 24, 40, 0.10);\n        background: var(--sdk-global-white-bg);\n        margin-top: 2px;\n        top: 34px;\n        border-radius: 4px;\n        width: 200px;\n\n        .close-drp-down {\n            float: right;\n            border: 0;\n            padding: 0;\n            background: transparent;\n            font-size: 14px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 20px;\n            height: 20px;\n            cursor: pointer;\n            margin: 5px;\n\n            svg {\n                path {\n                    fill: var(--sdk-gloabl-text-color);\n                }\n            }\n        }\n\n        li {\n            border-radius: 4px 4px 0px 0px;\n            background: var(--sdk-global-white-bg);\n            display: flex;\n            padding: 5px 16px;\n            width: 100%;\n            align-items: center;\n            align-self: stretch;\n            gap: 10px;\n            cursor: pointer;\n            transition: 0.2s all ease;\n            list-style-type: none;\n        }\n    }\n\n    .main-heading-wrapper {\n        padding: 10px;\n        display: flex;\n        align-items: center;\n        gap: 10px;\n\n        h1 {\n            color: var(--sdk-gloabl-text-color);\n            font-size: 18px;\n            font-weight: 600;\n            line-height: 20px;\n            width: 100%;\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n        }\n\n        .header-actions {\n            display: flex;\n            align-items: center;\n            flex-shrink: 0;\n            gap: 10px;\n            position: relative;\n\n            .btn-action-filter {\n                width: 16px;\n                height: 16px;\n                padding: 0;\n                border: 0;\n                background: transparent;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                font-size: 14px;\n                cursor: pointer;\n\n                svg {\n                    path {\n                        fill: var(--sdk-gloabl-text-color);\n                    }\n                }\n            }\n\n            .input-search {\n                position: absolute;\n                right: 0;\n                top: -8px;\n                width: 146px;\n                height: 34px;\n                padding: 6px 10px;\n                font-size: 14px;\n                font-weight: 400;\n                line-height: 20px;\n                border-radius: 8px;\n                border: 1px solid var(--sdk-gloabl-border-color);\n                background: var(--sdk-global-white-bg);\n                box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n                color: var(--sdk-gloabl-text-color);\n                outline: 0;\n                z-index: 1;\n\n                &::placeholder {\n                    color: var(--sdk-gloabl-text-color);\n                    font-size: 14px;\n                    font-weight: 400;\n                    line-height: 20px;\n                    opacity: 0.5;\n                }\n\n                &:focus {\n                    border: 1px solid var(--sdk-global-theme-color);\n                    box-shadow: 0px 0px 0px 4px var(--sdk-global-theme-color), 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n                }\n\n                &:active {\n                    border: 1px solid var(--sdk-global-theme-color);\n                    box-shadow: 0px 0px 0px 4px var(--sdk-global-theme-color), 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n                }\n            }\n        }\n    }\n\n    .adv-parent-acc-list {\n        display: inline-block;\n        width: 100%;\n        height: 100%;\n        position: relative;\n\n        &.open-acc-adv-temp {\n            .advanced-list-template-wrapper {\n                .right-actions-content {\n                    .arrow-icon {\n                        transform: rotate(90deg);\n                    }\n                }\n            }\n\n            .adv-list-temp-accordion {\n                display: block;\n            }\n        }\n\n        .advanced-list-template-wrapper {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            padding: 10px;\n            gap: 15px;\n\n            .border-div-indication {\n                flex-shrink: 0;\n                border-radius: 4px;\n            }\n\n            .img-block {\n                flex-shrink: 0;\n                width: 40px;\n                height: 40px;\n\n                &.xs {\n                    width: 16px;\n                    height: 16px;\n                }\n\n                &.lg {\n                    width: 60px;\n                    height: 60px;\n                }\n\n                &.xlg {\n                    width: 80px;\n                    height: 80px;\n                }\n\n                figure {\n                    line-height: 0px;\n                }\n\n                img {\n                    width: 100%;\n                    height: 100%;\n                    border-radius: 8px;\n\n                    &.radius-100 {\n                        border-radius: 100%;\n                    }\n                }\n            }\n\n            .titles-info-block {\n                width: 100%;\n\n                // overflow: hidden;\n                // white-space: nowrap;\n                // text-overflow: ellipsis;\n                h1 {\n                    color: var(--sdk-gloabl-text-color);\n                    font-size: 16px;\n                    font-weight: 600;\n                    line-height: normal;\n                    // overflow: hidden;\n                    // white-space: nowrap;\n                    // text-overflow: ellipsis;\n                    // width: 100%;\n                }\n\n                p {\n                    color: var(--sdk-gloabl-text-color);\n                    font-size: 14px;\n                    font-weight: 400;\n                    line-height: normal;\n                    letter-spacing: 0.271px;\n                    // overflow: hidden;\n                    // white-space: nowrap;\n                    // text-overflow: ellipsis;\n                    // width: 100%;\n                }\n            }\n\n            .right-actions-content {\n                flex-shrink: 0;\n                gap: 10px;\n                display: flex;\n                align-items: center;\n                justify-content: flex-end;\n\n                h1 {\n                    color: var(--sdk-gloabl-text-color);\n                    font-size: 14px;\n                    font-weight: 600;\n                    line-height: 20px;\n                }\n\n                .arrow-icon {\n                    font-size: 10px;\n                    width: 20px;\n                    height: 20px;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    border: 0;\n                    background: transparent;\n                    padding: 0;\n                    cursor: pointer;\n\n                    svg {\n                        path {\n                            fill: var(--sdk-gloabl-text-color);\n                        }\n                    }\n                }\n\n                .tag-status {\n                    display: flex;\n                    padding: 2px 6px;\n                    justify-content: center;\n                    align-items: center;\n                    gap: 10px;\n                    border-radius: 4px;\n                    background: var(--sdk-gloabl-bg-secondary);\n                    color: var(--green-2, #27AE60);\n                    font-size: 10px;\n                    font-weight: 400;\n                    line-height: 17px;\n                    margin: 0;\n                    border: 1px solid transparent;\n                }\n\n                .dropdown-list-wrapper {\n                    width: auto;\n                    position: relative;\n\n                    &.show-drp {\n                        .elipse-dropdown {\n                            background: var(--sdk-gloabl-bg-secondary);\n                        }\n\n                        .drp-content-menu {\n                            display: block;\n                        }\n                    }\n\n                    .elipse-dropdown {\n                        width: 24px;\n                        height: 24px;\n                        border: 0;\n                        background: transparent;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        padding: 0;\n                        font-size: 14px;\n                        border-radius: 4px;\n                        transition: 0.2s all ease;\n\n                        svg {\n                            path {\n                                fill: var(--sdk-gloabl-text-color);\n                            }\n                        }\n\n                        &:hover {\n                            background: var(--sdk-gloabl-bg-secondary);\n                        }\n                    }\n                }\n            }\n        }\n\n        .adv-list-temp-accordion {\n            padding: 10px;\n            -webkit-animation-name: slideOutDown;\n            animation-name: slideOutDown;\n            -webkit-animation-duration: 1s;\n            animation-duration: 1s;\n            -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n            display: none;\n            position: relative;\n            z-index: 2;\n\n            .list-of-rows {\n                display: flex;\n                flex-direction: column;\n                width: 100%;\n                gap: 8px;\n\n                .row-list-info {\n                    display: flex;\n                    align-items: flex-start;\n                    gap: 14px;\n\n                    figure {\n                        line-height: 0;\n                        position: relative;\n                        top: 2px;\n\n                        img {\n                            width: 16px;\n                            height: 16px;\n                        }\n                    }\n\n                    p {\n                        color: var(--sdk-gloabl-text-color);\n                        font-size: 12px;\n                        font-weight: 500;\n                        line-height: 19px;\n                        letter-spacing: 0.3px;\n                    }\n                }\n            }\n\n            .buttons-wrapper-sec {\n                display: flex;\n                gap: 10px;\n                margin-top: 10px;\n                position: relative;\n\n                &.if-full-width-buttons {\n                    flex-wrap: wrap;\n                }\n            }\n\n            .table-list-data {\n                display: flex;\n                flex-wrap: wrap;\n\n                &.if-column-type {\n                    .table-body-data {\n                        flex: 1 1 50%;\n                        flex-direction: row;\n                        align-items: center;\n                    }\n                }\n\n                .table-body-data {\n                    display: flex;\n                    align-items: flex-start;\n                    flex-direction: column;\n                    flex: 1 1 33.333%;\n                    padding: 10px;\n                    gap: 10px;\n\n                    .img_block {\n                        flex-shrink: 0;\n                        width: 30px;\n                        height: 30px;\n\n                        &.xs {\n                            width: 16px;\n                            height: 16px;\n                        }\n\n                        &.md {\n                            width: 40px;\n                            height: 40px;\n                        }\n\n                        &.lg {\n                            width: 60px;\n                            height: 60px;\n                        }\n\n                        &.xlg {\n                            width: 80px;\n                            height: 80px;\n                        }\n\n                        figure {\n                            line-height: 0px;\n                        }\n\n                        img {\n                            width: 100%;\n                            height: 100%;\n                            border-radius: 8px;\n\n                            &.radius-100 {\n                                border-radius: 100%;\n                            }\n                        }\n                    }\n\n                    .titles_info_block {\n                        width: 100%;\n\n                        p {\n                            color: var(--sdk-gloabl-text-color);\n                            font-size: 14px;\n                            font-weight: 400;\n                            line-height: normal;\n                            margin-bottom: 2px;\n                        }\n\n                        h1 {\n                            color: var(--sdk-gloabl-text-color);\n                            font-size: 14px;\n                            font-weight: 600;\n                            line-height: normal;\n                            letter-spacing: 0.271px;\n                        }\n                    }\n                }\n            }\n\n            .checkbox-list-data-tems {\n                display: flex;\n                flex-direction: column;\n                gap: 2px;\n                width: 100%;\n\n                .checkbox-item {\n                    width: 100%;\n                }\n\n                .radio-button-item {\n                    .radio-input {\n                        width: 25px;\n                        height: 25px;\n                        top: 9px;\n                        left: 10px;\n\n                        &:checked {\n                            +.radio-label {\n                                background: var(--sdk-gloabl-bg-secondary);\n                            }\n                        }\n\n                        +.radio-label {\n                            padding: 12px 10px;\n                            padding-left: 46px;\n                            width: 100%;\n                            border-radius: 4px;\n\n                            &::before {\n                                left: 10px;\n                                top: 8px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .see-more-link {\n        padding: 10px;\n        text-align: right;\n\n        .see-more-btn {\n            display: inline-flex;\n            padding: 5px 10px;\n            align-items: center;\n            gap: 10px;\n            border: 0;\n            color: var(--sdk-global-theme-color);\n            text-align: center;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 20px;\n            background: transparent;\n            height: 34px;\n\n            svg {\n                path {\n                    fill: var(--sdk-gloabl-text-color);\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
